import React from 'react'
import classNames from 'classnames'

import type { Modify, SoapTemplateTab } from '~/types'

import { RightRailOverlayProvider } from '../../context/RightRailOverlayContext'
import { SoapMainContent } from '../../SoapMainContent'
import { SoapAppointmentDetailsHeader } from './SoapAppointmentDetailsHeader'
import { SoapPatientMedicalRecordRightRail } from './SoapPatientMedicalRecordRightRail'

import '@chewy/kib-layout-styles/dist/styles/kib-grid.css'
import styles from './SoapV3Layout.module.scss'

interface SoapV3LayoutProps {
  currentTab: Modify<SoapTemplateTab, { id: string }> | undefined
  soapTabs: Modify<SoapTemplateTab, { id: string }>[] | undefined
}

export const SoapV3Layout = ({ soapTabs, currentTab }: SoapV3LayoutProps) => (
  <div
    className={classNames(
      styles.layoutWrapper,
      'kib-grid',
      'kib-grid--align-left',
      'kib-grid--valign-top',
    )}
  >
    <div
      className={classNames(
        styles.mainContent,
        'kib-grid__item',
        'kib-grid__item--span-7@lg',
        'kib-grid__item--span-7@xl',
      )}
    >
      <SoapAppointmentDetailsHeader />
      <SoapMainContent
        hideHeader
        currentTab={currentTab}
        hideSoapRail={() => {}}
        rightRailVisible={false}
        soapRailClasses={{
          contentWithoutRail: '',
          contentWithRail: '',
          rightRail: '',
          expandedRail: '',
          hidden: '',
        }}
        soapTabs={soapTabs}
      />
    </div>

    <div
      className={classNames(
        styles.rightRail,
        'kib-grid__item',
        'kib-grid__item--span-5@lg',
        'kib-grid__item--span-5@xl',
      )}
    >
      <RightRailOverlayProvider>
        <SoapPatientMedicalRecordRightRail />
      </RightRailOverlayProvider>
    </div>
  </div>
)
